import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UsersService } from '../../../../core/services/users/users.service';
import { Subject } from 'rxjs/Subject';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { User } from './user.model';
import { fuseAnimations } from '../../../../core/animations';
import 'rxjs/add/observable/zip';
import { MatSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { USER_ROLE, UserProfile } from '../../../../core/services/users/profile.model';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'fuse-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  animations   : fuseAnimations
})
export class UserComponent implements OnInit {

    isAdmin = false;
    user: User;
    // companies: CompanyResult[];
    routeParams: any;
    onUserChanged: Subject<any> = new Subject();
    userRoles = [
        {
            title: USER_ROLE.ADMIN,
            value: USER_ROLE.ADMIN
        },
        // {
        //     title: USER_ROLE.SUPERVISOR,
        //     value: USER_ROLE.SUPERVISOR
        // },
        // {
        //     title: USER_ROLE.OPERATOR,
        //     value: USER_ROLE.OPERATOR
        // }
    ];
    pageType: string;
    form: FormGroup;

    constructor(
        private authService: AuthService,
        private usersService: UsersService,
        // private companiesService: CompaniesService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        public snackBar: MatSnackBar,
        private location: Location,
    ) {}

    ngOnInit() {

        this.route.params.subscribe( params => {
            this.routeParams = params;
            if ( this.routeParams.id === 'new' )
            {
                this.pageType = 'new';
                this.user = new User();
                this.form = this.createForm();
                // this.companiesService.list().subscribe(companies => {
                //     this.companies = companies;
                //     this.form = this.createForm();
                // }, e => {
                //     this.snackBar.open('Une erreur est survenue lors de la sauvegarde', 'OK', {
                //             verticalPosition: 'bottom',
                //             duration        : 2000
                //         });
                // });
            }
            else
            {
                this.pageType = 'edit';
                const profile$ = this.usersService.get(this.routeParams.id);
                // const companies$ = this.companiesService.list();
                Observable
                    .zip(profile$/* , companies$ */, (profile: User/* , companies: CompanyResult[] */) => ({profile/* , companies */}))
                    .subscribe(pair => {
                        this.user = pair.profile;
                        // this.companies = pair.companies;
                        this.form = this.createForm();
                    });
            }

        });

    }

    createForm()
    {

        return this.formBuilder.group({
            _id                 : [this.user._id],
            email               : [this.user.email, [Validators.required, Validators.email]],
            role                : [this.user.role, Validators.required],
            // company             : !this.isAdmin ? new FormControl(this.authService.payload.company || '', Validators.required) : new FormControl(this.user.company || ''),
            password            : this.pageType === 'new' ? new FormControl('', Validators.required)
                                    : new FormControl(this.user.password || '', Validators.required),

            // [this.user.password],

            // annualRecurrence    : [this.user.annualRecurrence],
            // recurrenceStart     : [this.user.recurrenceStart, Validators.required],
            // recurrenceEnd       : [this.user.recurrenceEnd, Validators.required],
            // quantity            : [this.user.quantity],
            // tresholdAlert       : [this.user.tresholdAlert],
            // schedules           : [this.user.schedules],
            // tickets             : [this.user.tickets],
            // disabled            : [this.user.disabled],
        });

    }

    save()
    {
        const data = this.form.getRawValue();
        this.usersService.update(this.user._id, data).subscribe(res => {
            this.snackBar.open('Utilisateur sauvegardé', 'OK', {
                    verticalPosition: 'top',
                    duration        : 2000
                });
        }, e => {
            this.snackBar.open('Une erreur est survenue, cette adresse est peut-être déjà utilisée ?', 'OK', {
                    verticalPosition: 'bottom',
                    duration        : 2000
                });
        });
    }

    create()
    {
        const data = this.form.getRawValue();
        this.usersService.create(data).subscribe(res => {
            this.snackBar.open('Utilisateur sauvegardé', 'OK', {
                    verticalPosition: 'top',
                    duration        : 2000
                });
            this.location.go('users/' + res._id);
        }, e => {
            this.snackBar.open('Une erreur est survenue, cette adresse est peut-être déjà utilisée ?', 'OK', {
                    verticalPosition: 'bottom',
                    duration        : 2000
                });
        });
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/user/user.component.ts